import { createSelector } from 'reselect';
import { GameHelperView } from '@Selectors/builder/myArmyList/export/view/game-helper.view';
import { getArmy } from '@Selectors/user/selector/army.get';
import { getArmyListUnits } from '@Selectors/builder/myArmyList/export/exportSelector';
import { EntityView } from '@Selectors/builder/myArmyList/export/view/entity.view';
import { UnitOptionCategory } from '@Models';

export const ArmyListExportGameHelpersPresenter = createSelector(
  [getArmy, getArmyListUnits],
  (army, armyListUnits): GameHelperView => {
    const units = army?.units ?? [];
    const options = armyListUnits
      .filter((unit) => unit.army_list_unit_unit_options.length > 0)
      .flatMap((armyListUnit) => {
        const unit =
          units.find((unit) => unit.id === armyListUnit.unit_id) ?? null;
        if (!unit) return [];

        return unit.optionGroups
          .flatMap((o) => o.options)
          .filter((option) => option.category === UnitOptionCategory.MagicPath)
          .filter((option) =>
            armyListUnit.army_list_unit_unit_options.some(
              (armyListUnitUnitOption) =>
                armyListUnitUnitOption.unit_option_id === option.id,
            ),
          );
      })
      .map(
        (option) =>
          ({
            id: option.magic_path_id ?? 0,
            name: option.name,
          }) satisfies EntityView as EntityView,
      )
      .filter((option) => option.id !== 0);

    return {
      armyId: army?.id ?? 0,
      hasArmySpell: (army?.spells?.length || 0) > 0,
      magicPathIds: options,
    } satisfies GameHelperView as GameHelperView;
  },
);
